import { render, staticRenderFns } from "./Comissionamento.vue?vue&type=template&id=0d86b523"
import script from "./Comissionamento.vue?vue&type=script&lang=ts"
export * from "./Comissionamento.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports